import { Action, any, async, jsxToWidget, nothing, stateful } from "widgets-for-react";
import { TeaserProps } from "../teaser";
import { RecentNewsBlockLayout } from "./recentNewsBlockLayout";
import { initialState, RecentNewsBlockProps, RecentNewsBlockState } from "./recentNewsBlockState";

export const RecentNewsBlock = (props: RecentNewsBlockProps) =>
  stateful<RecentNewsBlockState>({ key: 'recent_news_block' })(s0 =>
    any<Action<RecentNewsBlockState>>()([
      jsxToWidget(RecentNewsBlockLayout({ ...s0, ...props, key: 'recentNewsBlock' })),
      async<TeaserProps[]>(nothing, { key: 'recentNewsLoader' })(s0.items)
        .map(itemsUpdater => s1 => {
          return ({ items: itemsUpdater(s1.items) })
        })
    ]).map(a => a(s0))
  )(initialState(props)).run(_ => { })